import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=136b8af8&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"
import style0 from "./Nav.vue?vue&type=style&index=0&id=136b8af8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b8af8",
  null
  
)

export default component.exports